import { memo, useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'shards-react';
import { ADMIN_TOOLS_WRAPPER } from 'utils/constants.json';
import FilterIndicator from './components/FilterIndicator';
import FilterUsers from './components/FilterUsers';
import FilterReferences from './components/FilterReferences';
import SearchDocumentById from './components/SearchDocumentById';
import FilterByEnvelopeName from './components/FilterByEnvelopeName';

const AdminTools = ({ toggleModal, serviceID, serviceType, displayReference, isUserAdmin }) => {
  const [container, setContainer] = useState(() => null);
  const [showOptions, setShowOptions] = useState(() => false);

  const toggleOptions = useCallback(() => setShowOptions((prev) => !prev), []);

  useEffect(() => setContainer(document.getElementById(ADMIN_TOOLS_WRAPPER)), []);

  if (!container) return null;

  return createPortal(
    <Dropdown className='d-flex' open={showOptions} toggle={toggleOptions}>
      <FilterIndicator />
      <DropdownToggle title='Admin Tools' tag='i' className='fas fa-sliders-h my-auto pointer' />
      <DropdownMenu right className='rounded p-0'>
        {
          isUserAdmin &&
          <>
            <DropdownItem className='rounded p-2' toggle={false} tag='div'>
              <SearchDocumentById toggleModal={toggleModal} serviceID={serviceID} serviceType={serviceType} displayReference={displayReference} />
            </DropdownItem>
            <DropdownItem className='rounded p-2' toggle={false} tag='div'>
              <FilterUsers />
            </DropdownItem>
          </>          
        }
        {
          ['signature_envelopes'].includes(serviceType) &&
          <>
            <DropdownItem className='rounded p-2' toggle={false} tag='div'>
              <FilterByEnvelopeName />
            </DropdownItem>
          </>          
        }
        <DropdownItem className="rounded p-2" toggle={false} tag="div">
          <FilterReferences /> 
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>,
    container
  );
};

export default memo(AdminTools);
